var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAirc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1Artboard 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,54a4,4,0,0,1,4-4H66a8,8,0,1,0-7.54-10.69A3.87,3.87,0,0,1,54.87,42,4.14,4.14,0,0,1,51,36.39,16,16,0,1,1,66,58h-.17A16,16,0,1,1,36.76,70.86,3.78,3.78,0,0,1,40.4,66a4.27,4.27,0,0,1,4.07,2.7A8,8,0,0,0,60,65.2,8.24,8.24,0,0,0,51.64,58H22A4,4,0,0,1,18,54ZM33,36H22a4,4,0,0,0-4,4h0a4,4,0,0,0,4,4H33A13,13,0,0,0,46,30.79,13.18,13.18,0,0,0,32.25,18a13,13,0,0,0-10.08,5.81A4,4,0,0,0,25.53,30a4.14,4.14,0,0,0,3.37-1.86,5,5,0,0,1,5.54-1.94,4.93,4.93,0,0,1,3.37,3.4A5,5,0,0,1,33,36Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirc);
export default __webpack_public_path__ + "static/media/AIRC.ac44fc28.svg";
export { ForwardRef as ReactComponent };